import React from 'react';
import './TopBar.css';

function TopBar({ title = "North America Watch - US Production" }) {
  return (
    <div className="topbar">
      <h1>{title}</h1>
    </div>
  );
}

export default TopBar;
